import anime from '@/assets/libs/anime';
import { SplitText } from '@/assets/libs/SplitText';
import { inApp } from '@/scripts/utils';

export function paragraphInit(el) {
  const ctx = el;

  if (inApp()) {
    anime.set(ctx, { translateY: 25, opacity: 0 });
  } else {
    let split;

    if (!ctx._isSplit) { // eslint-disable-line
      split = new SplitText(ctx, { type: 'lines, words', linesClass: 'paragraph__line' });
      ctx._splitInstance = split; // eslint-disable-line
      ctx.setAttribute('data-splitted', '');
    } else {
      split = ctx._splitInstance; // eslint-disable-line
    }
    anime.set(split.lines, {
      translateY: '150%',
      opacity: 0,
      transformOrigin: '50% 100% 0',
    });
  }
}

export function paragraphAnim(el, delay = 0) {
  const ctx = el;
  let animation;

  if (inApp()) {
    animation = anime({
      targets: ctx,
      translateY: 0,
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1000,
      opacity: {
        value: 1,
        duration: 700,
        delay: delay + 100,
      },
      update: (a) => {
        if (a.progress > 60 && !ctx.dataset.animateLines) {
          ctx.setAttribute('data-animate-lines', '');
        }
      },
      delay,
    });
  } else {
    const lines = [...ctx.querySelectorAll('.paragraph__line')];

    animation = anime({
      targets: lines,
      translateY: 0,
      opacity: {
        value: 1,
        duration: 1400,
        delay: anime.stagger(150, { start: delay + 100 }),
      },
      transformOrigin: '50% 100% 0',
      delay: anime.stagger(150, { start: delay }),
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1800,
      update: (a) => {
        if (a.progress > 60 && !ctx.dataset.animateLines) {
          ctx.setAttribute('data-animate-lines', '');
        }
      },
      complete: () => {
        ctx.setAttribute('data-animated', '');
      },
    });
  }

  return animation;
}

export function paragraphOut(el, delay = 0) {
  const ctx = el;
  let animation;

  if (inApp()) {
    animation = anime({
      targets: ctx,
      translateY: -25,
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1000,
      opacity: {
        value: 0,
        duration: 500,
      },
      delay,
    });
  } else {
    let split;

    if (!ctx._isSplit) { // eslint-disable-line
      split = new SplitText(ctx, { type: 'lines, words', linesClass: 'paragraph__line' });
      ctx._splitInstance = split; // eslint-disable-line
      ctx.setAttribute('data-splitted', '');
    } else {
      split = ctx._splitInstance; // eslint-disable-line
    }

    animation = anime({
      targets: split.lines,
      translateY: '-150%',
      opacity: {
        value: 0,
        duration: 500,
      },
      transformOrigin: '50% 0% 0',
      delay: anime.stagger(150, { start: delay }),
      easing: 'cubicBezier(.87,.43,.38,1)',
      duration: 1000,
    });
  }

  return animation;
}
